import { gql } from '@apollo/client';

const GET_SEIZURES_PAGED = gql`
    query seizuresPaged($first: Int, $after: String) {
        seizuresPaged(first: $first, after: $after) {
            pageInfo {
                hasNextPage
                endCursor
            }
            edges {
                node {
                    id
                    date
                    locationName
                    courtCases {
                        id
                        docket
                    }

                    administrativeLevel1 {
                        id
                        name
                    }
                    officers {
                        id
                        firstName
                        lastName
                    }
                    seizedCommodities {
                        id
                        species {
                            id
                            commonName
                        }
                        unit
                        originName
                        protectionLevel {
                            label
                        }
                        count
                        weightGrams
                        value
                        valueCurrency
                    }
                }
            }
        }
    }
`;

export default GET_SEIZURES_PAGED;
